import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


router.beforeEach((to, from, next) => {

  //console.log(from)
 

  if (to.matched.some(record => record.meta.requiresParam)) {
    
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    console.log('Eccomi')
    if (1==0) {
      //console.log('Eccomi')
      next({
        path: '/desk/0',
        
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})